const DISMISS_URL = '/wp-json/packback/v1/banner/dismiss';

export default (el) => {
  const $banner = $(el);
  const $close = $banner.find('.js-banner-close');

  $close.on('click', async () => {
    try {
      await fetch(DISMISS_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: '{}'
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }

    $banner.slideUp(150);
  });
};